exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".preview-data-message {\n  color: #3040C4;\n}\nselect#column {\n  font-size: 1.2rem;\n}\nbutton#detect {\n  font-size: 1.5rem;\n}\n.fraud-message {\n  font-size: 1.5rem;\n}\n.fraud-message i {\n  font-size: 3.5rem;\n}\n.warning {\n  color: #F2C94C;\n  font-size: 3rem;\n}", ""]);

// exports
